import request from "../request";

import { REACT_BASE_URL_GAMA_USERS } from "../url";

export const getMyProfileRequest = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/profile`,
    method: "GET",
  });
};

export const updateMyProfile = async (data) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/profile`,
    method: "PATCH",
    data: data,
  });
};

export const uploadProfilePictureOnBucket = async (file) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/upload/dev-gama-profile-images/user-images/${file?.name}`,
    method: "PUT",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: file,
  });
};

export const updateProfilePicture = async (file, userId = undefined) => {
  return request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/profile/image`,
    method: "PATCH",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: {
      file,
      userId,
    },
  });
};

export const getProfilePicture = async (userId = undefined) => {
  const url = userId
    ? `${REACT_BASE_URL_GAMA_USERS}/users/profile/image?userId=${userId}`
    : `${REACT_BASE_URL_GAMA_USERS}/users/profile/image`;
  return await request({
    url,
    method: "GET",
  });
};

export const getProfileIdentityCardImage = async (userId, documentType) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/profile/get-documents/${userId}?documentType=${documentType}`,
    method: "GET",
  });
};
